<template>
  <v-container fluid>
    <div class="main">

      <div class="text-end mb-3">
        <v-btn color="gifty"
               dark
               class="rounded-lg"
               depressed
               @click="addItem"
        >
          <v-icon left>mdi-plus</v-icon>
          Ajouter
        </v-btn>
      </div>

      <v-overlay :value="overlay" absolute color="white" opacity="0.5">
        <v-progress-circular
            color="primary"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>

      <v-row>
        <v-col cols="12">
          <v-card class="rounded-lg shadow">
            <v-card-title class="flex-wrap" style="gap: 12px">
              <div style="min-width: 260px">
                <v-text-field hide-details
                              v-model="keyword"
                              rounded
                              filled
                              dense
                              append-icon="mdi-magnify"
                              single-line
                              clearable
                              placeholder="Rechercher..."
                              v-on:keyup.enter="fetchData"
                />
              </div>

              <v-spacer/>


            </v-card-title>

            <v-divider/>

            <v-card-text class="pa-0">

              <div v-if="isLoading">
                <v-skeleton-loader type="table"></v-skeleton-loader>
              </div>

              <div v-else>
                <v-data-table :headers="headers"
                              :items="filteredCampaigns"
                              :search="keyword"
                              no-data-text="Aucun jeu trouvé"
                              no-results-text="Aucun résultat pour cette recherche"
                >

                  <template v-slot:item.status="{ item }">
                    <v-switch v-model="item.is_active"
                              class="pa-0 ma-0"
                              color="success"
                              hide-details
                              readonly
                              @click="changeStatus(item.id)"></v-switch>

                  </template>

                  <template v-slot:item.visuals="{ item }">
                    <div class="d-flex align-center py-2">

                      <v-avatar v-if="item.logo" size="44" tile class="rounded mr-3 grey lighten-4">
                        <v-img :src="fileUrl(item.logo)" contain/>
                      </v-avatar>
                      <v-avatar v-else size="44" tile class="rounded mr-3 grey lighten-4">
                        <v-icon color="grey">mdi-image-off-outline</v-icon>
                      </v-avatar>

                      <v-chip   small outlined>
                        <v-icon left small>mdi-gift-outline</v-icon>
                        {{ item.gifts.length }} cadeau{{ item.gifts.length > 1 ? 'x' : '' }}
                      </v-chip>

                    </div>
                  </template>

                  <template v-slot:item.type="{ item }">
                    <v-chip  style="background: transparent">
                      <v-icon left>
                        {{ item.type === 'memory_game' ? 'mdi-cards-outline' : 'mdi-ferris-wheel' }}
                      </v-icon>
                      {{ item.type === 'memory_game' ? 'Memory game' : 'Spin to win' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.start_date="{ item }">
                    <v-chip
                        :style="{ background: 'rgba(25,233,18,0.12)', color: '#19e912' }"
                    >
                      <v-icon left small color="success">mdi-calendar-start</v-icon>
                      {{ item.start_date }}
                    </v-chip>
                  </template>


                  <template v-slot:item.end_date="{ item }">
                    <v-chip
                        :style="{ background: 'rgba(233,18,18,0.12)', color: '#e91212' }"
                    >
                      <v-icon left small color="error">mdi-calendar-end</v-icon>
                      {{ item.end_date }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <div class="d-flex align-center">
                      <v-btn icon @click="updateItem(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="remove(item.id)">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>
                  </template>

                </v-data-table>


              </div>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <AddDialog ref="addDialog" @refresh="fetchData"/>

    </div>
  </v-container>
</template>

<script>
import AddDialog from "./components/AddDialog.vue";
import {HTTP} from "@/http-common";

export default {
  components: {
    AddDialog,
  },
  data() {
    return {
      FILE_URL: process.env.VUE_APP_FILE_URL,
      isLoading: false,
      overlay: false,
      delete_id: null,
      keyword: null,
      typeFilter: 'all',
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Visuels',
          value: 'visuals',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'type',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Début',
          value: 'start_date',
        },
        {
          text: 'Fin',
          value: 'end_date',
        },
        {
          text: 'Order',
          value: 'order',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      campaigns: [],
    };
  },
  computed: {
    filteredCampaigns() {
      if (this.typeFilter === 'all') return this.campaigns;
      return this.campaigns.filter(c => (c.type ?? 'spintowin') === this.typeFilter);
    },
  },
  methods: {
    /** Full URL for an image (works with full URLs or relative paths) */
    fileUrl(path) {
      if (!path) return "";
      if (/^(https?:|blob:|data:)/.test(path)) return path;

      const base = (this.FILE_URL || "").replace(/\/+$/, "");
      return `${base}/${String(path).replace(/^\/+/, "")}`;
    },
    countByType(type) {
      return this.campaigns.filter(c => (c.type ?? 'spintowin') === type).length;
    },
    memoryPreview(item) {
      return (item.memory_images ?? []).filter(Boolean).slice(0, 3);
    },
    memoryExtra(item) {
      return Math.max((item.memory_images ?? []).filter(Boolean).length - 3, 0);
    },
    fetchData() {
      this.isLoading = true
      HTTP.get('/v1/spintowins').then(res => {
        this.campaigns = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    addItem() {
      this.$refs.addDialog.open();
    },
    updateItem(item) {
      this.$refs.addDialog.edit(item);
    },
    openGifts(id) {
      this.$refs.giftsDialog.open(id);
    },
    remove(id) {
      this.delete_id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/spintowins/delete", {
        id: this.delete_id,
      }).then(() => {
        this.overlay = false;
        let i = this.campaigns.findIndex((el) => el.id === this.delete_id);
        this.$delete(this.campaigns, i);
        this.delete_id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/spintowins/change-status", {
        id: id,
      }).then(() => {
        this.overlay = false;
        let index = this.campaigns.findIndex(el => el.id === id)
        this.campaigns[index].is_active = !this.campaigns[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
  },
}
</script>

<style>
</style>